import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IUser } from "../../../../interfaces/IUser";
import { IUserResellerMapping } from "../_models/IUserResellerMapping";
import { IUserResellerMappingQueryOptions } from "../_models/IUserResellerMappingQueryOptions";

@Injectable({
    providedIn: 'root'
})
export class FoundationUserResellerMappingService {
    constructor(private readonly http: HttpClient) {}

    getMappings(options: IUserResellerMappingQueryOptions = {}): Observable<IUserResellerMapping[]> {
        return this.http.get<IUserResellerMapping[]>("/api/foundation/userResellerMappings", { params: options as HttpParams });
    }

    getCurrentUserMappings(): Observable<IUserResellerMapping[]> {
        return this.http.get<IUserResellerMapping[]>("/api/foundation/userResellerMappings/current");
    }

    updateMappings(user: IUser): Observable<IUserResellerMapping[]> {
        return this.http.post<IUserResellerMapping[]>(`/api/foundation/userResellerMappings/update/${user.Id}`, user.ResellerIds);
    }
}
